
<template lang="pug">
  .notification-preferences-page
    p Shopify may still contact me about order information such as order confirmations, when my order ships, and when orders are delivered.
    p(aria-live="alert")
      b(v-if="subscribed") You are currently subscribed to Ratio Food news and offers by email.
      b(v-if="!subscribed") You are not currently subscribed to Ratio Food news and offers by email.
    form(v-if="!subscribed" @submit.prevent="subscribe" v-disable-all="!loaded")
      .row
        label.checkbox-input
          input(type="checkbox" name="over18" id="user_over18" v-model="subscribe_checkbox" required)
          span.checkbox-input__checkbox.checkbox--toggle-all.toggle-all-true
            <svg class="icon" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z" fill="currentColor"/></svg>
          .checkbox-input__label-text By signing up, you are accepting our <a href="https://www.generalmills.com/privacy-security/us-english-privacy-policy" target="_blank">Privacy Policy</a> and agreeing that your information may be used across our <a href="https://www.generalmills.com/food-we-make/brands" target="_blank">family of brands</a>.
      div
        button.btn.btn--primary(type="submit" id="account-subscription") Subscribe
    form(v-else @submit.prevent="unsubscribe" v-disable-all="!loaded")
      div
        button.btn.btn--primary(type="submit" id="account-subscription") UnSubscribe
</template>

<script>
  export default {
    name: 'NotificationPreferences',

    components: {
    },

    props: {
    },

    setup() {
    },

    mounted() {
      fetch(
        this.$parent.url + 'customer_subscriptions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.$parent.getSession())
        }
      ).then(response => response.json()).then((data) => {
        console.log(data)
        this.subscriptions = data.Subscriptions.filter((v) => v.subscribed);
        this.subscribed = this.subscriptions.length != 0;
        this.loaded = true;
      });
    },

    data() {
      return {
        loaded: false,
        subscribed: false,
        subscribe_checkbox: false,
        submitted: false,
        subscriptions: []
      }
    },

    validations () {
      return {
      }
    },

    methods: {
      subscribe() {
        fetch(
          this.$parent.url + 'subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.$parent.getSession())
          }
        ).then(response => response.json()).then(data => {
          if (data.cdata)
            this.$parent.setSession(data);
          if (data.UnifiedId)
            this.subscribed = true;
            this.submitted = true;
        }).then(() => {
          if (this.submitted) {
            this.$el.querySelector('button[type=submit]').focus();
          }
        });
      },

      unsubscribe() {
        fetch(
          this.$parent.url + 'unsubscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign({ subscription_id: this.subscriptions[0].subscriptionId }, this.$parent.getSession()))
          }
        ).then(response => response.json()).then(() => {
          this.subscribed = false;
          this.submitted = true;
        }).then(() => {
          if (this.submitted) {
            this.$el.querySelector('button[type=submit]').focus();
          }
        });
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
